import { createAction, createActionGroup, props } from '@ngrx/store';

// Models
import { User } from '@core/models/maintainer.interface';



export const MaintainerUsersActions = createActionGroup({
  source: 'Recovery',
  events: {
    'do something': props<{ payload: any }>(),
  },
});


export const MaintainerUsersEffectsActions = createActionGroup({
  source: 'API Recovery',
  events: {
    'create user': props<{ user: Partial<User> }>(),
    'get users': props<any>(),
    'inject users': props<{ users: User[] }>(),
    'fill out user form selectors': props<any>(),
    'inject user form selectors': props<{ selectors: any }>(),
    'edit user': props<{ id: number, user: User }>(),
    'inject user': props<{ updatedUser: User }>(),
    'trigger user status': props<{ id: number, user: User }>(),
    'inject error': props<{ error: string }>(),
  },
});
